import PropTypes from 'prop-types';
import React from 'react';
import { encode as encodeBase64 } from 'base-64';

import { noop } from 'lodash';

import { ConfigsService, LocaleService, WindowProxy, UrlService } from '@sm360/widget-commons-core-services';
import { AccountService, ModalService, REDIRECTIONS } from '@sm360/widget-commons-general';
import QuoteActions from 'commons-vehicle/Quote/actions/quoteActions.js';
import ShowroomService from 'commons-vehicle/services/ShowroomService/ShowroomService.js';
import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25.js';
import AddToGarageV25 from 'commons-vehicle/Quote/components/AddToGarageV25/AddToGarageV25.jsx';

import 'commons-vehicle/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.scss';

class BuyOnlineCTAV25 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            iconClass: props.iconClass,
            classNames: ['btn-get-started', props.buttonClass, 'vehicle-cta-btn'],
        };

        this.buyOnline = this.buyOnline.bind(this);
        this.onBuyOnline = this.onBuyOnline.bind(this);
        this.saveQuote = this.saveQuote.bind(this);
        this.buyOnline = this.buyOnline.bind(this);
        this.onCloseCallBacks = {
            onClose: (params) => {
                const newAccount = params && params.newAccount;
                if (AccountService.isAuthenticated()) {
                    this.buyOnline(newAccount);
                }
                return true;
            },
        };
    }

    onBuyOnline() {
        this.props.onClick();
        if (ConfigsService.isInMobileApp()) {
            this.saveQuote();
        } else if (!AccountService.isAuthenticated()) {
            const LoginModal = ModalService.get('login/SignUpModal');
            LoginModal.addCallbacks(this.onCloseCallBacks);
            LoginModal.open({ submitAccountCreationLead: false });
        } else {
            this.setState({
                iconClass: 'icon-refresh',
                classNames: ['btn-get-started', this.props.buttonClass, 'vehicle-cta-btn', 'clicked'],
            });
            this.saveQuote();
        }
    }

    buyOnline() {
        if (AccountService.isAuthenticated()) {
            this.setState({
                iconClass: 'icon-refresh',
                classNames: ['btn-get-started', this.props.buttonClass, 'vehicle-cta-btn', 'clicked'],
            });
            this.saveQuote();
        }
        return true;
    }

    doCheckoutRedirect(quote) {
        const { onEndProcessGaTag } = this.props;
        const locale = LocaleService.getSimpleLocale();
        const url = REDIRECTIONS[locale].checkout;
        const windowProxy = WindowProxy.get();

        if (windowProxy) {
            const historyUrl = quote.buildUrl(windowProxy.location.href);

            windowProxy.history.replaceState({ quote }, 'tradeIn', historyUrl);

            let fullUrl = quote.buildUrl(url);
            if (onEndProcessGaTag) {
                fullUrl += `&${UrlService.encodeUriParameter(
                    'onEndProcessGaTag',
                    encodeBase64(JSON.stringify(onEndProcessGaTag))
                )}`;
            }

            if (ConfigsService.isInMobileApp() && !AccountService.isAuthenticated()) {
                windowProxy.location.href =
                    `ca.solutionsmedias360.showroom-${ConfigsService.getWebsiteId()}://` +
                    `?action=login&redirectUrl=${encodeURIComponent(fullUrl)}`;
            } else {
                windowProxy.location.href = fullUrl;
            }
        }
    }

    saveQuote(newAccount) {
        const { quote } = this.props;

        const addToGarageV25 = new AddToGarageV25();

        addToGarageV25.addOrUpdateQuote(quote, newAccount).then((quoteId) => {
            UrlService.addOrReplaceParameter('quoteId', quoteId);
            const interval = setInterval(
                () =>
                    ShowroomService.searchQuoteV25(quoteId).then((updatedQuote) => {
                        if (updatedQuote.leadId) {
                            QuoteActions.setQuoteV25(updatedQuote);
                            addToGarageV25.dispatchAddToGarage();
                            clearInterval(interval);
                            this.doCheckoutRedirect(updatedQuote);
                        }
                    }),
                2000
            );
        });
    }

    render() {
        const { iconClass, classNames } = this.state;
        return (
            <button className={classNames.join(' ')} type="button" onClick={this.onBuyOnline}>
                {iconClass && <icon className={iconClass} />}
                <span>{this.props.alternativeLabel || LocaleService.t('CALL_TO_ACTION.BTN_BUY_ONLINE_TITLE')}</span>
            </button>
        );
    }
}

BuyOnlineCTAV25.defaultProps = {
    alternativeLabel: '',
    buttonClass: 'sr-button-1',
    iconClass: null,
    onClick: noop,
    onEndProcessGaTag: null,
};

BuyOnlineCTAV25.propTypes = {
    alternativeLabel: PropTypes.string,
    buttonClass: PropTypes.string,
    quote: PropTypes.instanceOf(QuoteModelV25).isRequired,
    iconClass: PropTypes.string,
    onClick: PropTypes.func,
    onEndProcessGaTag: PropTypes.shape({
        category: PropTypes.string.isRequired,
        action: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }),
};

BuyOnlineCTAV25.displayName = 'BuyOnlineCTAV25';

export default BuyOnlineCTAV25;
